import { useState } from "react"
import { Button, Col, Form, Row } from "react-bootstrap"
import useUXStore from "../../api/ux/store"
import ButtonControl from "../../components/ButtonControl"
import BaseControl from "../../components/BaseControl"
import { AccessData } from "../../api/companies/data"
import { useCompanies } from "../../api/companies/store"
import { USER_BLOCKED_STATUS_STRING } from "../../constants"


const ACCESS_VERIFIED = "verified"

const InviteComp = ({ com = "", email = "", onInvited = () => { }, onFailed = () => { } }) => {
    const [_email, setEmail] = useState(email)
    const { inviteOwner } = useCompanies(state => state)
    const [inviting, setInviting] = useState(false)
    const onChangedEmail = (pemail: string) => {
        setEmail(pemail)
    }
    const onInvite = () => {
        setInviting(true)
        inviteOwner(com, _email)
            .then(code => {
                // TODO: check issues
                switch (code) {
                    case "200":
                        onInvited()
                        break;

                    default:
                        onFailed()
                        break;
                }
            })
            .finally(() => setInviting(false))
    }
    return <>
        <Form.Control disabled={inviting} defaultValue={email} type="email" onChange={e => onChangedEmail(e.target.value)} />
        <Row>
            <Col><Button disabled={inviting}
                style={{ float: "right", marginTop: "10px" }}
                onClick={() => onInvite()}>{email ? "Resend" : "Invite"}</Button></Col>
        </Row>
    </>
}

type InviteOwnerProps = {
    access: AccessData
    com: string
}

const InviteOwner: React.FC<InviteOwnerProps> = ({ access, com }) => {
    const { refreshDialog, hideDialog, addToast } = useUXStore(state => state)
    const { unblockOwner } = useCompanies(state => state)
    const [unblockingStatus, setUnblockingStatus] = useState<"idle" | "sending" | "sent">("idle")

    const onInviteSuccess = () => {
        hideDialog("inviteUser")
        addToast("", "Invite Success", null,)
    }
    const onInviteFailed = () => {
        addToast("", "Invite Failed", null, "danger")
    }
    const onClickInvite = () => {
        refreshDialog({
            id: "inviteUser",
            title: "Invite Owner",
            visible: true,
            content: <InviteComp
                email={access ? access.email : ""}
                com={com}
                onInvited={onInviteSuccess}
                onFailed={onInviteFailed}
            />,
            onConfirm: undefined,
        }, true)
    }
    const onUnblock = () => {
        if (!access?.username) return
        setUnblockingStatus("sending")
        unblockOwner(access.username).then(success => {
            if (success) {
                setUnblockingStatus("sent")
                addToast("", "Unblock Success", null)
                // Optionally reset after some time
                setTimeout(() => setUnblockingStatus("idle"), 5000)
            } else {
                setUnblockingStatus("idle")
                addToast("", "Unblock Failed", null, "danger")
            }
        })
    }
    const getUnblockLabel = () => {
        switch (unblockingStatus) {
            case "sending": return "Sending..."
            case "sent": return "Sent"
            default: return "Unblock"
        }
    }
    return <>
        {!access && <ButtonControl text="Invite Owner" buttonLabel="Invite" variant="outline-primary" onClicked={onClickInvite} />}
        {access && access.status === ACCESS_VERIFIED &&
            (access.overall_status === USER_BLOCKED_STATUS_STRING ?
                <BaseControl
                    text="Owner"
                    caption={access!.email + (unblockingStatus === "sent" ? " (Reset Link Sent)" : " (Blocked)")}
                >
                    <div style={{ display: "flex", gap: "10px", justifyContent: "flex-end", alignItems: "center" }}>
                        <Button
                            size="sm"
                            variant={unblockingStatus === "sent" ? "outline-success" : "outline-danger"}
                            onClick={onUnblock}
                            disabled={unblockingStatus !== "idle"}
                        >
                            {getUnblockLabel()}
                        </Button>
                        <Button
                            size="sm"
                            variant="outline-primary"
                            onClick={onClickInvite}
                        >
                            Change
                        </Button>
                    </div>
                </BaseControl> :
                <ButtonControl text="Owner" caption={access!.email + "(" + access?.status + ")"} variant="outline-primary" buttonLabel="Change" onClicked={onClickInvite} />
            )
        }
        {access && access.status !== ACCESS_VERIFIED &&
            <ButtonControl text="Owner Invite" variant="outline-primary" caption={access!.email + "(" + access?.status + ")"} buttonLabel="Resend" onClicked={onClickInvite} />
        }
    </>
}

export default InviteOwner